module.exports = __webpack_public_path__ + "static/media/10n.810f7538.svg";